import type {  Breakpoint } from '@mui/material/styles';
import Box from '@mui/material/Box';
import { useTheme } from '@mui/material/styles';
import type {} from '@mui/material/themeCssVarsAugmentation';
import { layoutClasses } from '../../helpers/utils';



export type LayoutSectionProps = {
  layoutQuery : Breakpoint;
  children?: React.ReactNode;
  footerSection?: React.ReactNode;
  headerSection?: React.ReactNode;
  sidebarSection?: React.ReactNode;
};

export function LayoutSection({
  layoutQuery,
  children,
  footerSection,
  headerSection,
  sidebarSection,
}: LayoutSectionProps) {
  const theme = useTheme();

  // const inputGlobalStyles = (
  //   // <GlobalStyles
  //   //   styles={{
  //   //     body: {
  //   //     '--layout-dashboard-content-pt': theme.spacing(1), // TODO use?
  //   //     '--layout-dashboard-content-pb': theme.spacing(8),
  //   //     '--layout-dashboard-content-px': theme.spacing(5),
  //   //     },
  //   //   }}
  //   // />
  // );

  return (
    <>
      {/* {inputGlobalStyles} */}

      <Box id="root__layout" className={layoutClasses.root} sx={{
                    [`& .${layoutClasses.hasSidebar}`]: {
                      [theme.breakpoints.up(layoutQuery)]: {
                        pl: "300px",
                      },
                    },
                
                  }}>
        {sidebarSection}
        <Box
          display="flex"
          flex="1 1 auto"
          flexDirection="column"
          className={layoutClasses.hasSidebar}
        >
          {headerSection}
          {children}
          {footerSection}
        </Box>
      </Box>
    </>
  );
}
